import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const GuildVerificationStep = ({ formData, errors, onChange }) => {
  const [verificationStatus, setVerificationStatus] = useState(null);
  const correctGuildName = "Maladapted Miscreants";

  const handleGuildNameBlur = () => {
    if (formData?.guildName) {
      if (formData?.guildName?.toLowerCase() === correctGuildName?.toLowerCase()) {
        setVerificationStatus('success');
      } else {
        setVerificationStatus('error');
      }
    } else {
      setVerificationStatus(null);
    }
  };

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-card rounded-xl p-4 md:p-5 lg:p-6 border border-border">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Shield" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-1">
              Guild Verification
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              Confirm your membership in Maladapted Miscreants
            </p>
          </div>
        </div>

        <div className="space-y-4 md:space-y-5">
          <div className="relative">
            <Input
              label="Guild Name"
              type="text"
              name="guildName"
              placeholder="Enter the exact guild name"
              value={formData?.guildName}
              onChange={onChange}
              onBlur={handleGuildNameBlur}
              error={errors?.guildName}
              required
              description="Type 'Maladapted Miscreants' to verify your guild membership"
            />
            
            {verificationStatus === 'success' && (
              <div className="absolute right-3 top-9 flex items-center gap-2 bg-success/10 px-3 py-1.5 rounded-lg">
                <Icon name="CheckCircle" size={16} color="var(--color-success)" />
                <span className="text-xs md:text-sm font-medium text-success">Verified</span>
              </div>
            )}
            
            {verificationStatus === 'error' && (
              <div className="mt-2 flex items-start gap-2 text-error text-sm">
                <Icon name="AlertCircle" size={16} className="flex-shrink-0 mt-0.5" />
                <span>Guild name does not match. Please enter 'Maladapted Miscreants' exactly.</span>
              </div>
            )}
          </div>

          <Input
            label="Officer Referral Code (Optional)"
            type="text"
            name="referralCode"
            placeholder="Enter code if provided by an officer"
            value={formData?.referralCode}
            onChange={onChange}
            error={errors?.referralCode}
            description="Speeds up approval process if you have one"
          />

          <div className="bg-muted/50 rounded-xl p-4 md:p-5">
            <div className="flex items-start gap-3">
              <Icon name="Users" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
              <div className="text-sm md:text-base">
                <p className="font-medium text-foreground mb-2">How to Get a Referral Code</p>
                <p className="text-muted-foreground mb-3">
                  Contact any guild officer in-game or through Discord to receive a referral code. 
                  This helps us verify new members faster.
                </p>
                <div className="space-y-1.5">
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-success)" />
                    <span className="text-xs md:text-sm">Instant approval with valid code</span>
                  </div>
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-success)" />
                    <span className="text-xs md:text-sm">Skip manual verification wait</span>
                  </div>
                  <div className="flex items-center gap-2 text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-success)" />
                    <span className="text-xs md:text-sm">Direct officer contact established</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-warning/10 rounded-xl p-4 md:p-5 border border-warning/20">
        <div className="flex items-start gap-3">
          <Icon name="AlertTriangle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm md:text-base">
            <p className="font-medium text-foreground mb-1">Verification Process</p>
            <p className="text-muted-foreground">
              Without a referral code, your account will be reviewed by guild officers within 24-48 hours. 
              You'll receive an email once approved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuildVerificationStep;